import { __awaiter } from "tslib";
import { axiosClient } from '@as-react/common-utils';
import { Environment } from '@as-react/common-utils';
class CategoryAPI {
    constructor() {
        this.getById = (servicesApi, defaultRequestParams, categoryId) => __awaiter(this, void 0, void 0, function* () {
            const { mainWebshop, language } = defaultRequestParams;
            const endpoint = Environment.isDevelopment() ? 'http://localhost:4502/' : `${servicesApi}api/`;
            const axiosConfig = {
                method: 'GET',
                url: `${endpoint}services/public/category/${mainWebshop}/${categoryId}/${language}`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
    }
}
export default new CategoryAPI();
